const US_MSAS = [
  "Abilene TX MSA",
  "Aguadilla PR MSA",
  "Albany GA MSA",
  "Albany-Schenectady-Troy NY MSA",
  "Albuquerque NM MSA",
  "Alexandria LA MSA",
  "Allentown-Bethlehem-Easton PA MSA",
  "Altoona PA MSA",
  "Amarillo TX MSA",
  "Anchorage AK MSA",
  "Anniston AL MSA",
  "Appleton-Oshkosh-Neenah WI MSA",
  "Asheville NC MSA",
  "Athens GA MSA",
  "Atlanta GA MSA",
  "Auburn-Opelika AL MSA",
  "Augusta-Aiken GA-SC MSA",
  "Austin-San Marcos TX MSA",
  "Bakersfield CA MSA",
  "Bangor ME MSA",
  "Barnstable-Yarmouth MA MSA",
  "Baton Rouge LA MSA",
  "Beaumont-Port Arthur TX MSA",
  "Bellingham WA MSA",
  "Benton Harbor MI MSA",
  "Billings MT MSA",
  "Biloxi-Gulfport-Pascagoula MS MSA",
  "Binghamton NY MSA",
  "Birmingham AL MSA",
  "Bismarck ND MSA",
  "Bloomington IN MSA",
  "Bloomington-Normal IL MSA",
  "Boise City ID MSA",
  "Boston-Worcester-Lawrence MA-NH-ME-CT CMSA",
  "Brownsville-Harlingen-San Benito TX MSA",
  "Bryan-College Station TX MSA",
  "Buffalo-Niagara Falls NY MSA",
  "Burlington VT MSA",
  "Canton-Massillon OH MSA",
  "Casper WY MSA",
  "Cedar Rapids IA MSA",
  "Champaign-Urbana IL MSA",
  "Charleston WV MSA",
  "Charleston-North Charleston SC MSA",
  "Charlotte-Gastonia-Rock Hill NC-SC MSA",
  "Charlottesville VA MSA",
  "Chattanooga TN-GA MSA",
  "Cheyenne WY MSA",
  "Chicago-Gary-Kenosha IL-IN-WI CMSA",
  "Chico-Paradise CA MSA",
  "Cincinnati-Hamilton OH-KY-IN CMSA",
  "Clarksville-Hopkinsville TN-KY MSA",
  "Cleveland-Akron OH CMSA",
  "Colorado Springs CO MSA",
  "Columbia MO MSA",
  "Columbia SC MSA",
  "Columbus GA-AL MSA",
  "Columbus OH MSA",
  "Corpus Christi TX MSA",
  "Corvallis OR MSA",
  "Cumberland MD-WV MSA",
  "Dallas-Fort Worth TX CMSA",
  "Danville VA MSA",
  "Davenport-Moline-Rock Island IA-IL MSA",
  "Dayton-Springfield OH MSA",
  "Daytona Beach FL MSA",
  "Decatur AL MSA",
  "Decatur IL MSA",
  "Denver-Boulder-Greeley CO CMSA",
  "Des Moines IA MSA",
  "Detroit-Ann Arbor-Flint MI CMSA",
  "Dothan AL MSA",
  "Dover DE MSA",
  "Dubuque IA MSA",
  "Duluth-Superior MN-WI MSA",
  "Eau Claire WI MSA",
  "El Paso TX MSA",
  "Elkhart-Goshen IN MSA",
  "Elmira NY MSA",
  "Enid OK MSA",
  "Erie PA MSA",
  "Eugene-Springfield OR MSA",
  "Evansville-Henderson IN-KY MSA",
  "Fargo-Moorhead ND-MN MSA",
  "Fayetteville NC MSA",
  "Fayetteville-Springdale-Rogers AR MSA",
  "Flagstaff AZ-UT MSA",
  "Florence AL MSA",
  "Florence SC MSA",
  "Fort Collins-Loveland CO MSA",
  "Fort Myers-Cape Coral FL MSA",
  "Fort Pierce-Port St. Lucie FL MSA",
  "Fort Smith AR-OK MSA",
  "Fort Walton Beach FL MSA",
  "Fort Wayne IN MSA",
  "Fresno CA MSA",
  "Gadsden AL MSA",
  "Gainesville FL MSA",
  "Glens Falls NY MSA",
  "Goldsboro NC MSA",
  "Grand Forks ND-MN MSA",
  "Grand Junction CO MSA",
  "Grand Rapids-Muskegon-Holland MI MSA",
  "Great Falls MT MSA",
  "Green Bay WI MSA",
  "Greensboro--Winston-Salem--High Point NC MSA",
  "Greenville NC MSA",
  "Greenville-Spartanburg-Anderson SC MSA",
  "Harrisburg-Lebanon-Carlisle PA MSA",
  "Hartford CT MSA",
  "Hattiesburg MS MSA",
  "Hickory-Morganton-Lenoir NC MSA",
  "Honolulu HI MSA",
  "Houma LA MSA",
  "Houston-Galveston-Brazoria TX CMSA",
  "Huntington-Ashland WV-KY-OH MSA",
  "Huntsville AL MSA",
  "Indianapolis IN MSA",
  "Iowa City IA MSA",
  "Jackson MI MSA",
  "Jackson MS MSA",
  "Jackson TN MSA",
  "Jacksonville FL MSA",
  "Jacksonville NC MSA",
  "Jamestown NY MSA",
  "Janesville-Beloit WI MSA",
  "Johnson City-Kingsport-Bristol TN-VA MS",
  "Johnstown PA MSA",
  "Jonesboro AR MSA",
  "Joplin MO MSA",
  "Kalamazoo-Battle Creek MI MSA",
  "Kansas City MO-KS MSA",
  "Killeen-Temple TX MSA",
  "Knoxville TN MSA",
  "Kokomo IN MSA",
  "La Crosse WI-MN MSA",
  "Lafayette IN MSA",
  "Lafayette LA MSA",
  "Lake Charles LA MSA",
  "Lakeland-Winter Haven FL MSA",
  "Lancaster PA MSA",
  "Lansing-East Lansing MI MSA",
  "Laredo TX MSA",
  "Las Cruces NM MSA",
  "Las Vegas NV-AZ MSA",
  "Lawrence KS MSA",
  "Lawton OK MSA",
  "Lewiston-Auburn ME MSA",
  "Lexington KY MSA",
  "Lima OH MSA",
  "Lincoln NE MSA",
  "Little Rock-North Little Rock AR MSA",
  "Longview-Marshall TX MSA",
  "Los Angeles-Riverside-Orange County CA",
  "Louisville KY-IN MSA",
  "Lubbock TX MSA",
  "Lynchburg VA MSA",
  "Macon GA MSA",
  "Madison WI MSA",
  "Mansfield OH MSA",
  "Mayaguez PR MSA",
  "McAllen-Edinburg-Mission TX MSA",
  "Medford-Ashland OR MSA",
  "Melbourne-Titusville-Palm Bay FL MSA",
  "Memphis TN-AR-MS MSA",
  "Merced CA MSA",
  "Miami-Fort Lauderdale FL CMSA",
  "Milwaukee-Racine WI CMSA",
  "Minneapolis-St. Paul MN-WI MSA",
  "Missoula MT MSA",
  "Mobile AL MSA",
  "Modesto CA MSA",
  "Monroe LA MSA",
  "Montgomery AL MSA",
  "Muncie IN MSA",
  "Myrtle Beach SC MSA",
  "Naples FL MSA",
  "Nashville TN MSA",
  "New London-Norwich CT-RI MSA",
  "New Orleans LA MSA",
  "New York-Northern New Jersey-Long Island NY-NJ-CT-PA",
  "Norfolk-Virginia Beach-Newport News VA-NC",
  "Ocala FL MSA",
  "Odessa-Midland TX MSA",
  "Oklahoma City OK MSA",
  "Omaha NE-IA MSA",
  "Orlando FL MSA",
  "Owensboro KY MSA",
  "Panama City FL MSA",
  "Parkersburg-Marietta WV-OH MSA",
  "Pensacola FL MSA",
  "Peoria-Pekin IL MSA",
  "Philadelphia-Wilmington-Atlantic City PA-NJ-DE-MD CMSA",
  "Phoenix-Mesa AZ MSA",
  "Pine Bluff AR MSA",
  "Pittsburgh PA MSA",
  "Pittsfield MA MSA",
  "Pocatello ID MSA",
  "Ponce PR MSA",
  "Portland ME MSA",
  "Portland-Salem OR-WA CMSA",
  "Providence-Fall River-Warwick RI-MA MSA",
  "Provo-Orem UT MSA",
  "Pueblo CO MSA",
  "Punta Gorda FL MSA",
  "Raleigh-Durham-Chapel Hill NC MSA",
  "Rapid City SD MSA",
  "Reading PA MSA",
  "Redding CA MSA",
  "Reno NV MSA",
  "Richland-Kennewick-Pasco WA MSA",
  "Richmond-Petersburg VA MSA",
  "Roanoke VA MSA",
  "Rochester MN MSA",
  "Rochester NY MSA",
  "Rockford IL MSA",
  "Rocky Mount NC MSA",
  "Sacramento-Yolo CA CMSA",
  "Saginaw-Bay City-Midland MI MSA",
  "Salinas CA MSA",
  "Salt Lake City-Ogden UT MSA",
  "San Angelo TX MSA",
  "San Antonio TX MSA",
  "San Diego CA MSA",
  "San Francisco-Oakland-San Jose CA CMSA",
  "San Juan-Caguas-Arecibo PR CMSA",
  "San Luis Obispo-Atascadero-Paso Robles CA MSA",
  "Santa Barbara-Santa Maria-Lompoc CA MSA",
  "Santa Fe NM MSA",
  "Sarasota-Bradenton FL MSA",
  "Savannah GA MSA",
  "Scranton--Wilkes-Barre--Hazleton PA MSA",
  "Seattle-Tacoma-Bremerton WA CMSA",
  "Sharon PA MSA",
  "Sheboygan WI MSA",
  "Sherman-Denison TX MSA",
  "Shreveport-Bossier City LA MSA",
  "Sioux City IA-NE MSA",
  "Sioux Falls SD MSA",
  "South Bend IN MSA",
  "Spokane WA MSA",
  "Springfield IL MSA",
  "Springfield MA MSA",
  "Springfield MO MSA",
  "St. Cloud MN MSA",
  "St. Joseph MO MSA",
  "St. Louis MO-IL MSA",
  "State College PA MSA",
  "Steubenville-Weirton OH-WV MSA",
  "Stockton-Lodi CA MSA",
  "Sumter SC MSA",
  "Syracuse NY MSA",
  "Tallahassee FL MSA",
  "Tampa-St. Petersburg-Clearwater FL MSA",
  "Terre Haute IN MSA",
  "Texarkana TX-Texarkana AR MSA",
  "Toledo OH MSA",
  "Topeka KS MSA",
  "Tucson AZ MSA",
  "Tulsa OK MSA",
  "Tuscaloosa AL MSA",
  "Tyler TX MSA",
  "Utica-Rome NY MSA",
  "Victoria TX MSA",
  "Visalia-Tulare-Porterville CA MSA",
  "Waco TX MSA",
  "Washington-Baltimore DC-MD-VA-WV CMSA",
  "Waterloo-Cedar Falls IA MSA",
  "Wausau WI MSA",
  "West Palm Beach-Boca Raton FL MSA",
  "Wheeling WV-OH MSA",
  "Wichita Falls TX MSA",
  "Wichita KS MSA",
  "Williamsport PA MSA",
  "Wilmington NC MSA",
  "Yakima WA MSA",
  "York PA MSA",
  "Youngstown-Warren OH MSA",
  "Yuba City CA MSA",
  "Yuma AZ MSA"
];
export default US_MSAS;
